import { Component, OnInit, EventEmitter, Output } from '@angular/core';
 
import { first } from 'rxjs/operators';
import { AlertService, ReportsService, UploadExamCenterService } from 'src/app/shared';
import { TestbatchService } from 'src/app/shared/services/test-batch/testbatch.service';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.scss']
})
export class ReportHeaderComponent implements OnInit {


  
  @Output() onReport = new EventEmitter<any>();

  centers:any = [];
  batches:any = [];
  filter:any =  {

  };

  constructor(
   
    private uploadExamCenterService: UploadExamCenterService,
    private alert:AlertService,
    private testbatchService: TestbatchService,
    private reportService: ReportsService) { }

  ngOnInit() {
    this.searchUploadExamCenterList ();
    this.getBatch ();
    
  }



  getBatch() {
    this.testbatchService.getAll()
    .pipe(first())
    .subscribe(res => {
      this.batches = res;
    })
  }


  getReport (){
    var data ={
      centerid: this.filter.testcenter?this.filter.testcenter.center_id: '',
      batchid:this.filter.batch?this.filter.batch.code: '',
      candidate_id: this.filter.candidate_id? this.filter.candidate_id: ''
    };
    this.onReport.emit (data);
  }

  searchUploadExamCenterList() {
    this.uploadExamCenterService
      .searchExamCenterList(1, 1000, {})
      .pipe(first())
      .subscribe(res => {
         
        this.centers = res["data"];
      });
  }

}
